export default __webpack_public_path__ + "static/media/pacientes.118547e3.png";